// PowerPlantContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";
import { PowerplantInfo } from "../api";

interface PowerPlantDetails {
    id: string;
    name: string;
    imageUrl?: string;
    sharepointLibraryUrl: string;
    exampleQuestions: string[];
}

interface PowerPlantContextType {
    powerplants: Record<string, PowerplantInfo>; // Changed from Record<string, string>
    setPowerplants: (plants: Record<string, PowerplantInfo>) => void;

    selectedPlantId: string | null;
    setSelectedPlantId: (plantId: string | null) => void;

    selectedPlantDetails: PowerPlantDetails | null;
    setSelectedPlantDetails: (details: PowerPlantDetails | null) => void;

    isLoadingDetails: boolean;
    setIsLoadingDetails: (loading: boolean) => void;
}

const PowerPlantContext = createContext<PowerPlantContextType | undefined>(undefined);

export const PowerPlantProvider = ({ children }: { children: ReactNode }) => {
    const [powerplants, setPowerplants] = useState<Record<string, PowerplantInfo>>({});
    const [selectedPlantId, setSelectedPlantId] = useState<string | null>(null);
    const [selectedPlantDetails, setSelectedPlantDetails] = useState<PowerPlantDetails | null>(null);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);

    return (
        <PowerPlantContext.Provider
            value={{
                powerplants,
                setPowerplants,
                selectedPlantId,
                setSelectedPlantId,
                selectedPlantDetails,
                setSelectedPlantDetails,
                isLoadingDetails,
                setIsLoadingDetails
            }}
        >
            {children}
        </PowerPlantContext.Provider>
    );
};

export const usePowerPlant = () => {
    const context = useContext(PowerPlantContext);
    if (!context) {
        throw new Error("usePowerPlant must be used within PowerPlantProvider");
    }
    return context;
};
